import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useSpring, animated as a } from 'react-spring';
import loginStyles from './login.module.css';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import { Alert } from '@mui/material';

function SignUp() {
  const navigate = useNavigate();
  const { signup } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const fadeIn = useSpring({
    from: { opacity: 0, transform: 'translateY(30px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 120, friction: 20 }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    setTimeout(() => {
      const result = signup(email, password, name);
      if (result.success) {
        navigate('/');
      } else {
        setError(result.error);
      }
      setIsLoading(false);
    }, 500);
  };

  const handleUseTestAccount = () => {
    navigate('/login');
  };

  return (
    <div className={loginStyles.main}>
      <a.div style={fadeIn} className={loginStyles.container}>
        <div className={loginStyles.logo}>
          <HeadphonesIcon sx={{ fontSize: 60, color: '#000' }} />
        </div>
        <h2 className={loginStyles.h2}>Create Account</h2>
        <p className={loginStyles.p}>Welcome! Create your account to start listening</p>

        {error && (
          <Alert severity="error" sx={{ marginBottom: 2, width: '100%' }}>
            {error}
          </Alert>
        )}

        <form className={loginStyles.form} onSubmit={handleSubmit}>
          <div className={loginStyles.inputGroup}>
            <PersonIcon className={loginStyles.icon} />
            <input
              className={loginStyles.input}
              type="text"
              placeholder="Full Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className={loginStyles.inputGroup}>
            <EmailIcon className={loginStyles.icon} />
            <input
              className={loginStyles.input}
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className={loginStyles.inputGroup}>
            <LockIcon className={loginStyles.icon} />
            <input
              className={loginStyles.input}
              type="password"
              placeholder="Create password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength="6"
            />
          </div>

          <button
            type="submit"
            className={loginStyles.loginBtn}
            disabled={isLoading}
          >
            {isLoading ? 'Creating Account...' : 'Sign Up'}
          </button>

          <div className={loginStyles.divider}>
            <span>OR</span>
          </div>

          <button
            type="button"
            className={loginStyles.testBtn}
            onClick={handleUseTestAccount}
          >
            Use Test Account Instead
          </button>

          <div className={loginStyles.links}>
            <a href="/login" className={loginStyles.link}>
              Already have an account? Log in
            </a>
          </div>
        </form>

        <div className={loginStyles.testCredentials}>
          <p>Try our test account:</p>
          <span>test@podcast.com / test123</span>
        </div>
      </a.div>
    </div>
  );
}

export default SignUp;